import { render, staticRenderFns } from "./ResearchPaging.vue?vue&type=template&id=1087292a"
import script from "./ResearchPaging.vue?vue&type=script&lang=js"
export * from "./ResearchPaging.vue?vue&type=script&lang=js"
import style0 from "./ResearchPaging.vue?vue&type=style&index=0&id=1087292a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports